export default __webpack_public_path__ + "static/media/Img0011.51a26704.png";